// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2JG6S","footer":"ModalUpdate_footer__2LCTr"};